import { render } from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=template&id=6b51c1e3&scoped=true"
import script from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=style&index=0&id=6b51c1e3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b51c1e3"]])

export default __exports__